import type { GarmentCategory, Occasion, WardrobeItem } from './wardrobe';

export const MOODS = [
  'Comfortable',
  'Confident',
  'Romantic',
  'Polished',
  'Playful',
  'Relaxed',
] as const;

export type Mood = (typeof MOODS)[number];

export interface RecommendationRequest {
  occasion: Occasion;
  mood: Mood;
  lockedGarmentIds: string[];
  missingCategories: GarmentCategory[];
}

export interface OutfitRecommendation {
  id: string;
  garments: WardrobeItem[];
  lockedGarmentIds: string[];
  score: number;
  explanation: string;
}

export interface RecommendationsResponse {
  recommendations: OutfitRecommendation[];
  availableCategories: GarmentCategory[];
}

export interface WearLog {
  id: string;
  wornOn: string;
  occasion: Occasion;
  mood: Mood;
  garments: WardrobeItem[];
  createdAt: number;
}

export interface WearLogsResponse {
  logs: WearLog[];
}
